import { createSelector } from "reselect";
import { State } from "../state";

export const getLoginState = (state: State) => state.user;

export const getUser = createSelector(
  getLoginState,
  loginState => loginState.user
);

export const getUserRole = createSelector(
  getUser,
  user => user.username
);

export const getUserToken = createSelector(
  getUser,
  user => user.credentials.accessToken
);



// WEBPACK FOOTER //
// ./src/redirectComponent/selector.tsx